/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface AddScriptStepSentenceRequest
 */
export interface AddScriptStepSentenceRequest {
    /**
     * 
     * @type {string}
     * @memberof AddScriptStepSentenceRequest
     */
    sentence?: string;
}

/**
 * Check if a given object implements the AddScriptStepSentenceRequest interface.
 */
export function instanceOfAddScriptStepSentenceRequest(value: object): boolean {
    return true;
}

export function AddScriptStepSentenceRequestFromJSON(json: any): AddScriptStepSentenceRequest {
    return AddScriptStepSentenceRequestFromJSONTyped(json, false);
}

export function AddScriptStepSentenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddScriptStepSentenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'sentence': json['sentence'] == null ? undefined : json['sentence'],
    };
}

export function AddScriptStepSentenceRequestToJSON(value?: AddScriptStepSentenceRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'sentence': value['sentence'],
    };
}

